import React from 'react';
import PropTypes from 'prop-types';

const ShowPassIcon = (props) => {
  const { show } = props;

  return show
    ? (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 29 16"
        style={{ enableBackground: 'new 0 0 29 16' }}
        xmlSpace="preserve"
      >
        <g fill="#353638">
          <g>
            <path
              d="M28.83,8.1c-3.81-3.84-8.88-5.95-14.29-5.95c-0.01,0-0.03,0-0.04,0c0,0-0.01,0-0.02,0c-0.02,0-0.04,0-0.05,0
                    C9.07,2.18,4.04,4.29,0.26,8.1L0.14,8.22c-0.19,0.2-0.19,0.51,0,0.71c0.1,0.1,0.23,0.15,0.35,0.15s0.26-0.05,0.35-0.15L0.97,8.8
                    c2.62-2.64,5.88-4.42,9.43-5.2C8.93,4.79,7.99,6.61,7.99,8.65c0,3.59,2.92,6.5,6.5,6.5c3.58,0,6.5-2.92,6.5-6.5
                    c0-2.06-0.96-3.89-2.46-5.08c3.61,0.76,6.93,2.55,9.59,5.24c0.2,0.2,0.51,0.2,0.71,0C29.03,8.61,29.03,8.29,28.83,8.1L28.83,8.1z
                     M19.99,8.65c0,3.03-2.47,5.5-5.5,5.5c-3.03,0-5.5-2.47-5.5-5.5c0-3.02,2.44-5.47,5.45-5.5c0.02,0,0.05,0,0.07,0
                    C17.53,3.16,19.99,5.62,19.99,8.65L19.99,8.65z M19.99,8.65"
            />
          </g>
          <path
            d="M18,8.15c-0.28,0-0.5,0.22-0.5,0.5c0,1.66-1.35,3-3,3c-1.66,0-3-1.35-3-3c0-1.65,1.35-3,3-3
                c0.28,0,0.5-0.22,0.5-0.5c0-0.28-0.22-0.5-0.5-0.5c-2.2,0-4,1.79-4,4c0,2.21,1.79,4,4,4c2.21,0,4-1.79,4-4
                C18.5,8.37,18.28,8.15,18,8.15L18,8.15z M18,8.15"
          />
        </g>
      </svg>
    )
    : (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 29 16"
        style={{ enableBackground: 'new 0 0 29 16' }}
        xmlSpace="preserve"
      >

        <path
          fill="#353638"
          id="Path_33"
          d="M28.86,8.33c-2.14-2.09-4.72-3.67-7.55-4.64l3.73-2.88c0.2-0.15,0.24-0.43,0.09-0.62
            c0-0.01-0.01-0.01-0.01-0.02c-0.16-0.2-0.46-0.23-0.66-0.07l-4.22,3.25c-1.85-0.52-3.76-0.78-5.68-0.78H14.5h-0.05
            c-5.3,0-10.39,2.06-14.19,5.76L0.14,8.44C-0.04,8.62-0.05,8.92,0.13,9.1c0.01,0.01,0.01,0.01,0.02,0.02
            C0.24,9.21,0.37,9.26,0.5,9.26c0.13,0,0.26-0.05,0.35-0.14l0.11-0.11c2.61-2.54,5.88-4.28,9.44-5.03C8.89,5.14,8,6.94,7.99,8.86
            c0,1.13,0.32,2.24,0.91,3.2l-4.05,3.13c-0.2,0.15-0.24,0.43-0.09,0.62c0,0.01,0.01,0.01,0.01,0.02c0.16,0.2,0.46,0.23,0.66,0.07
            l4-3.09c1.26,1.49,3.11,2.35,5.06,2.34c3.53,0.05,6.44-2.76,6.51-6.29c0-1.41-0.49-2.78-1.39-3.87l0.75-0.57
            c2.92,0.89,5.59,2.47,7.78,4.6c0.2,0.19,0.51,0.19,0.71,0c0.19-0.18,0.2-0.48,0.02-0.67C28.87,8.34,28.86,8.33,28.86,8.33z M9,8.86
            c0.06-2.97,2.49-5.34,5.45-5.32h0.07c1.35,0,2.66,0.49,3.67,1.39L9.7,11.45C9.24,10.67,9,9.77,9,8.86z M20,8.86
            c-0.05,2.99-2.51,5.37-5.5,5.32c-1.65,0.01-3.21-0.72-4.28-1.98l8.6-6.62C19.59,6.51,20,7.67,20,8.86z M18.98,4.31
            c-0.14-0.13-0.28-0.26-0.44-0.38c0.24,0.05,0.47,0.11,0.71,0.17L18.98,4.31z"
        />
      </svg>
    );
};


ShowPassIcon.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default ShowPassIcon;



// WEBPACK FOOTER //
// ./src/assets/ShowPassIcon.jsx